var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "label",
    {
      staticClass: "checkbox-input",
      on: {
        click: function($event) {
          return _vm.toggleCheckbox()
        }
      }
    },
    [
      _c(
        "span",
        {
          staticClass: "checkbox-input__checkbox checkbox--toggle-all",
          class: `toggle-all--${this.checkedState}`
        },
        [_c("icon", { attrs: { name: _vm.iconName, size: "12px" } })],
        1
      ),
      _vm.label
        ? _c("div", { staticClass: "checkbox-input__label-text" }, [
            _vm._v(_vm._s(_vm.label))
          ])
        : _c(
            "div",
            { staticClass: "checkbox-input__label-text" },
            [_vm._t("default")],
            2
          )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }